import { color, Common, device } from '@stockbit/ui';
import styled from 'styled-components';

const { Flex, Autocomplete, Text } = Common;

/**
 * Search and input container
 */

const InputContainer = styled(Flex)`
  padding-bottom: 16px;
  flex-direction: column;
  width: 100%;

  @media ${device.tablet} {
    flex-direction: row;
    align-items: center;
    width: auto;
  }
`;

const Label = styled(Text).attrs({ as: 'label' })`
  font-size: 14px;
  font-weight: bold;
  padding-bottom: 8px;

  @media ${device.tablet} {
    padding: 0px;
  }
`;

const SearchContainer = styled(Autocomplete)`
  width: 80%;

  input::placeholder {
    font-family: var(--font-bold);
    color: ${color.midgray};
  }

  @media ${device.tablet} {
    margin: 0 15px;
    width: 120px;
  }
`;

const Input = styled.input`
  padding: 5px 15px;
  font-size: 13px;
  height: 30px;
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 2px;
  background: ${color.light};

  :focus {
    outline: 0;
  }
`;

/**
 * Select containers
 */

const SelectContainer = styled(Flex)`
  border: 1px solid ${color.gainsboro};
  border-radius: 2px;
  width: 80%;
  padding: 0 4px;

  @media ${device.tablet} {
    margin: 0 15px;
    width: 100%;
  }
`;

const SelectInner = styled.select`
  background-color: ${color.light};
  border: 0px;
  height: 30px;
  width: 100%;
  padding: 0 12px;
`;

const Option = styled.option``;

/**
 * Target price main container
 */

const TargetPriceContainer = styled(Flex)`
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid ${color.downgray};
  border-radius: 3px;
  flex-direction: column;
  & > div:not(:first-of-type) {
    label {
      display: none;
    }
  }

  @media ${device.tablet} {
    flex-direction: row;
    & > div:not(:first-of-type) {
      label {
        display: block;
      }
    }
  }
`;

const FooterContainer = styled(Flex)`
  justify-content: flex-end;
  width: 100%;
  button {
    font-size: 14px;
    border: none;
    background: ${color.light};
    color: ${color.silver};
    cursor: pointer;
    :focus {
      outline: 0;
    }
  }
`;

export {
  Input,
  InputContainer,
  Label,
  SearchContainer,
  SelectContainer,
  SelectInner,
  TargetPriceContainer,
  FooterContainer,
  Option,
};
